/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type { VideoSurveyImpressionInputScenarioId } from './videoSurveyImpressionInputScenarioId'

/**
 * アンケートの提示到達（到達→完了ファネルの土台・ADR-0015）。
 */
export interface VideoSurveyImpressionInput {
  /** @nullable */
  scenarioId?: VideoSurveyImpressionInputScenarioId
  sessionId: string
}
